import { render } from "./MobileSlideFour.vue?vue&type=template&id=244b7fe2"
import script from "./MobileSlideFour.vue?vue&type=script&lang=js"
export * from "./MobileSlideFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__